import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from '../Tabs/Tabs';
import ErrorHelper from "../Errors/ErrorHelper";
import I18n from "i18n-js";
import HelperTemplateBuilderWorkspace from "./HelperTemplateBuilderWorkspace";


class HelperTemplateBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: [],
      active_tab: 'general',
      tabs: [],
      name: this.props.helper_template.name ? this.props.helper_template.name : '',
      code: this.props.helper_template.code ? this.props.helper_template.code : '',
      status: this.props.helper_template.status ? this.props.helper_template.status : '',
      body: this.props.helper_template.body ? this.props.helper_template.body : '',
      updated_at: this.props.helper_template.updated_at ? this.props.helper_template.updated_at : '',
    };
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

 

  render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSubmit,
      },
    ]

    return (
      <div className="FormFieldBuilder" ref="form">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons buttons={buttons} />
          <HelperTemplateBuilderWorkspace
            {...this.state} 
            onChange={this.onChange}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />  
      </div>
    );
  }

  tabs(){
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, ['code', 'name', 'body', 'status']),
        },
      ]
    );
  };

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab});
  }

  onChange(name, event) {
    this.state[name] =
      event && event.target && typeof event.target.value !== "undefined"
        ? event.target.value
        : event;
    this.forceUpdate(() => {
      if (typeof this.props.onChange == "function") {
        this.props.onChange(this.state);
      }
    });
  }

  onSubmit() {
    var self = this
    self.setState({ loading: true})
    setTimeout(function () {
      $.ajax({
        type: self.props.is_new ? 'POST' : 'PATCH',
        url: self.props.is_new
        ? self.props.paths.helper_template_create_path
        : self.props.paths.helper_template_save_path,
        data: {
          helper_template : {
            name: self.state.name,
            code: self.state.code,
            status: self.state.status,
            body: self.state.body,
            updated_at: self.state.updated_at,        
          },
        } 
      }).done(function (data) {
        if(Object.keys(data.errors).length) {
          self.setState({
            errors: data.errors,
            loading: false
          })
        } else {
          if (parent && parent.refresh_data) {
            if (self.props.is_new == true) {
              parent.refresh_data(I18n.t('helper_template_created_successfully'));
            } else {
              parent.refresh_data(I18n.t('helper_template_saved_successfully'));
            }
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal()
          }
        }  
      }).catch((data) => {
        if (data && data.responseJSON) {
          self.setState({errors: data.responseJSON, loading: false})
          $('.modal-body').scrollTop(0)
        }
      })
    }, 1000)
  };
  
}
export default HelperTemplateBuilder;